
import { Modal, ModalProps } from '@mui/material';
import React from 'react';

const ModalWrapper: React.FC<ModalProps> = ({ ...props }) => <Modal {...props} />;

export default ModalWrapper;
